module.exports = __webpack_public_path__ + "static/media/eduOrange.3c76d64a.svg";